import React, { useState } from "react";
import { Grid2 as Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { AddCircleOutline, ExpandMore } from '@mui/icons-material';
import { CustomControlledInput } from "./CustomControlledInput";
import { BoxSpaceCenter } from "../style/box";
import { RegisterButton } from "../style/button";
import { TypographyBold } from '../style/typography';

const PartnerRegistration = ({ control, companies, openDialog, handleRegistSubmit, expanded = false, isDisabled }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

    return (
        <Grid size={{ xs: 12 }}>
            <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="partner-registration-content"
                    id="partner-registration-header"
                >
                    <TypographyBold>新規連絡先担当者登録</TypographyBold>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3}>
                        {/* 所属会社 */}
                        <Grid size={{ xs: 12, md: 3 }}>
                            <CustomControlledInput
                                name="registPartnerCompanyPerson.companies"
                                control={control}
                                label="所属会社"
                                type="select"
                                multiple={false}
                                options={companies.map((c) => ({
                                    value: c.uuid,
                                    label: c.name
                                }))}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 氏名 */}
                        <Grid size={{ xs: 12, md: 3 }}>
                            <CustomControlledInput
                                name="registPartnerCompanyPerson.name"
                                control={control}
                                label="氏名"
                                variant="outlined"
                                placeholder="山田太郎"
                                inputProps={{ maxLength: 20 }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 電話番号 */}
                        <Grid size={{ xs: 12, md: 3 }}>
                            <CustomControlledInput
                                name="registPartnerCompanyPerson.tel"
                                control={control}
                                label="電話番号（ハイフン無し）"
                                placeholder="09012345678"
                                inputProps={{ maxLength: 11, pattern: '[0-9]*' }}
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                                }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 主担当者フラグ */}
                        <Grid size={{ xs: 12, md: 3 }}>
                            <CustomControlledInput
                                name="registPartnerCompanyPerson.is_main_person"
                                control={control}
                                label="主担当者"
                                type="checkbox"
                                sx={{ mt: 1 }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 登録ボタン */}
                        <Grid container size={{ xs: 12 }} justifyContent="center">
                            <Grid size={{ xs: 12, md: 6 }}>
                                <BoxSpaceCenter>
                                    <form
                                        style={{ width: "100%" }}
                                        onSubmit={handleRegistSubmit((data) => { openDialog('register', data.registPartnerCompanyPerson); })}
                                    >
                                        <RegisterButton
                                            fullWidth
                                            type="submit"
                                            variant="contained"
                                            startIcon={<AddCircleOutline />}
                                            disabled={isDisabled}
                                        >
                                            担当者を登録
                                        </RegisterButton>
                                    </form>
                                </BoxSpaceCenter>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default PartnerRegistration;